import { render, staticRenderFns } from "./ClientResponsibleForm.vue?vue&type=template&id=441cc425&"
import script from "./ClientResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./ClientResponsibleForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientResponsibleForm.vue?vue&type=style&index=0&id=441cc425&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports